import { FC, useState } from 'react';
import { AppliedFiltersContext } from './AppliedFiltersContext';

export const AppliedFiltersContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [appliedFilters, setAppliedFilters] = useState({});

  return (
    <AppliedFiltersContext.Provider
      value={{
        appliedFilters,
        setAppliedFilters,
      }}
    >
      {children}
    </AppliedFiltersContext.Provider>
  );
};
